import { $getUserWashings } from "@/utils/endpoints";

const state = () => ({
  washings: [],
  userId: null,
});

const getters = {
  washings: (state) => state.washings,
};

const mutations = {
  setWashings: (state, newValue) => (state.washings = newValue),
};

const actions = {
  getUserWashings: async ({ commit }, { userId, token }) => {
    const res = await $getUserWashings(userId, token);
    commit("setWashings", res);
  },
};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
